import {
  DailyTacticalBlockerAlert,
  DailyTacticalOpsReport,
  DailyTacticalWeeklyReview,
} from '../../services/operationsApi';

export default function Atu2OpsAutomationPanel({
  opsReport,
  weeklyReview,
  blockerAlert,
  error,
}: Props) {
  return (
    <section className="atu2-panel">
      <div className="atu2-section-head">
        <div>
          <span className="atu2-kicker">Ops automation</span>
          <h2>자동 운영 루프</h2>
        </div>
        <span className={`atu2-pill ${blockerAlert?.severity || 'warning'}`}>
          {statusLabel(opsReport, blockerAlert)}
        </span>
      </div>
      {error && <div className="atu2-state error">API 오류: {error}</div>}
      <div className="atu2-ops-grid">
        <OpsBox
          label="Daily ops"
          value={opsReport?.ready_for_stage_a_daily_ops ? '통과' : '조치 필요'}
          detail={opsReport?.run
            ? `${opsReport.run.trading_date} · ${opsReport.run.model_output_status}`
            : 'run 없음'}
        />
        <OpsBox
          label="Lifecycle"
          value={opsReport?.run?.market_payload_coverage.complete ? 'coverage OK' : 'coverage 부족'}
          detail={coverageText(opsReport)}
        />
        <OpsBox
          label="Weekly review"
          value={`${weeklyReview?.reviewed_run_count ?? 0} runs`}
          detail={backlogText(weeklyReview)}
        />
        <OpsBox
          label="Alert"
          value={blockerAlert?.alert_required ? blockerAlert.severity : 'clear'}
          detail={blockerText(blockerAlert)}
        />
      </div>
      <div className="atu2-ops-columns">
        <IssueList title="필요 조치" items={opsReport?.ops_actions_required || []} />
        <IssueList title="개선 backlog" items={weeklyReview?.improvement_backlog || []} />
        <IssueList title="현재 blocker" items={blockerAlert?.blockers || []} />
      </div>
    </section>
  );
}

function OpsBox({ label, value, detail }: OpsBoxProps) {
  return (
    <div className="atu2-rehearsal-box">
      <span>{label}</span>
      <strong>{value}</strong>
      <p>{detail}</p>
    </div>
  );
}

function IssueList({ title, items }: IssueListProps) {
  return (
    <div className="atu2-detail-box">
      <h3>{title}</h3>
      {items.length ? (
        <ul>{items.map((item) => <li key={item}><span>{item}</span></li>)}</ul>
      ) : (
        <p>없음</p>
      )}
    </div>
  );
}

function statusLabel(
  opsReport: DailyTacticalOpsReport | null,
  blockerAlert: DailyTacticalBlockerAlert | null,
) {
  if (blockerAlert?.severity === 'critical') return 'critical';
  if (blockerAlert?.severity === 'warning') return 'warning';
  return opsReport?.ready_for_stage_a_daily_ops ? 'clear' : 'pending';
}

function coverageText(opsReport: DailyTacticalOpsReport | null) {
  const coverage = opsReport?.run?.market_payload_coverage;
  if (!coverage) return '데이터 없음';
  return `open ${coverage.usable_open_count} · OHLC ${coverage.usable_ohlc_next_open_count}`;
}

function backlogText(weeklyReview: DailyTacticalWeeklyReview | null) {
  const items = weeklyReview?.improvement_backlog || [];
  return items.length ? `${items.length}개 backlog` : 'backlog 없음';
}

function blockerText(blockerAlert: DailyTacticalBlockerAlert | null) {
  const blockers = blockerAlert?.blockers || [];
  return blockers.length ? `${blockers.length}개 blocker` : 'blocker 없음';
}

type Props = {
  opsReport: DailyTacticalOpsReport | null;
  weeklyReview: DailyTacticalWeeklyReview | null;
  blockerAlert: DailyTacticalBlockerAlert | null;
  error: string | null;
};

type OpsBoxProps = {
  label: string;
  value: string;
  detail: string;
};

type IssueListProps = {
  title: string;
  items: string[];
};
